// import {
//   disableBodyScroll,
//   enableBodyScroll,
//   clearAllBodyScrollLocks
// } from 'body-scroll-lock';

export default {
  methods: {
    openSiteDrawer(reference) {
      // Animate page if behavior is push
      const pushElement = this.$root.$refs[reference].pushElement ? document.querySelector(this.$root.$refs[reference].pushElement) : null;
      if (pushElement) {
        pushElement.style.left = `-${this.$root.$refs[reference].width}`
      }

      // Fix sticky and fixed positioned elements
      if (this.$root.$refs[reference].reserveScrollBarGap) {
        const stickyElements = document.querySelectorAll('.is-sticky')

        const scrollbarWidth = window.innerWidth - document.documentElement.getBoundingClientRect().width
        const id = "style-noscroll"
        let $style = document.getElementById(id)

        if ($style) {
          return
        }

        if (scrollbarWidth > 0) {
          stickyElements.forEach(element => {
            element.style.left = parseInt(window.getComputedStyle(element).getPropertyValue('left'), 10) + 'px'
          })

          $style = document.createElement("style")
          $style.id = id
          $style.type = "text/css"
          $style.innerHTML = `.is-fixed {margin-right: ${scrollbarWidth}px;}`
          document.getElementsByTagName("head")[0].appendChild($style)
        }
      }

      // Disable body scroll
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      // disableBodyScroll(target, {
      //   reserveScrollBarGap: this.$root.$refs[reference].reserveScrollBarGap,
      // })

      this.$root.$refs[reference].open = true
      this.$root.$refs[reference].$emit('open')
      setTimeout(() => {
        this.$root.$refs[reference].$emit('opened')
      }, 500)
    },
    closeSiteDrawer(reference) {
      // Restore page if behavior is push
      const pushElement = this.$root.$refs[reference].pushElement ? document.querySelector(this.$root.$refs[reference].pushElement) : null;
      if (pushElement) {
        pushElement.style.left = "0px"
      }

      // Enable body scroll
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      // enableBodyScroll(target, {
      //   reserveScrollBarGap: this.$root.$refs[reference].reserveScrollBarGap
      // })

      // Remove style element
      if (document.getElementById("style-noscroll")) document.getElementById("style-noscroll").remove()

      this.$root.$refs[reference].open = false

      this.$root.$refs[reference].$emit('close')

      // Remove style element
      if (this.$root.$refs[reference].reserveScrollBarGap) {
        if (document.getElementById("style-noscroll")) document.getElementById("style-noscroll").remove()
      }

      this.$root.$refs[reference].$emit('closed')
    },
    toggleSiteDrawer(reference) {
      this.$root.$refs[reference].$emit('toggle')

      if (this.$root.$refs[reference].open) {
        this.closeSiteDrawer(reference)
      } else {
        this.openSiteDrawer(reference)
      }
    },
  }
}